import { call, put } from 'redux-saga/effects'

import { Community as CommunityTypes } from '../types'
import { Community as CommunityApi } from '../api'

const {
  FETCH_COMMUNITYS_ERROR,
  FETCH_COMMUNITYS_SUCCESS
} = CommunityTypes

export default function* () {
  try {
    const response = yield call(CommunityApi.fetchCommunitys)
    yield put({
      type: FETCH_COMMUNITYS_SUCCESS,
      payload: {
        communitys: response.data
      }
    })
  } catch (err) {
    yield put({
      type: FETCH_COMMUNITYS_ERROR,
      payload: {
        message: err.message
      }
    })
  }
}
